var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 61,
    viewBox: "0 0 53 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9946 2.1076C16.6335 0.815875 17.9467 0 19.3781 0H33.6219C35.0534 0 36.3665 0.815875 37.0054 2.1076L37.8571 3.8125H49.2143C51.3083 3.8125 53 5.51978 53 7.625C53 9.73022 51.3083 11.4375 49.2143 11.4375H3.78571C1.69529 11.4375 0 9.73022 0 7.625C0 5.51978 1.69529 3.8125 3.78571 3.8125H15.1429L15.9946 2.1076ZM3.67924 15.25H49.2143V53.375C49.2143 57.5807 45.819 61 41.6429 61H11.2507C7.17511 61 3.67924 57.5807 3.67924 53.375V15.25ZM13.1435 24.7812V51.4688C13.1435 52.5172 14.1018 53.375 15.0364 53.375C16.1839 53.375 16.9292 52.5172 16.9292 51.4688V24.7812C16.9292 23.7328 16.1839 22.875 15.0364 22.875C14.1018 22.875 13.1435 23.7328 13.1435 24.7812ZM24.5007 24.7812V51.4688C24.5007 52.5172 25.4589 53.375 26.3935 53.375C27.5411 53.375 28.3929 52.5172 28.3929 51.4688V24.7812C28.3929 23.7328 27.5411 22.875 26.3935 22.875C25.4589 22.875 24.5007 23.7328 24.5007 24.7812ZM35.9643 24.7812V51.4688C35.9643 52.5172 36.8161 53.375 37.8571 53.375C38.8982 53.375 39.75 52.5172 39.75 51.4688V24.7812C39.75 23.7328 38.8982 22.875 37.8571 22.875C36.8161 22.875 35.9643 23.7328 35.9643 24.7812Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.63b4712ddaf9d076cf3ab403aa2881b6.svg";
export { ForwardRef as ReactComponent };